module.exports = __webpack_public_path__ + "img/19.04cd4abe.png";